import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';

const useCssVars = () => {
  const theme = useTheme();

  return useMemo(() => {
    return {
      '--nav-bg': theme.palette.secondary.main,
      '--nav-color': theme.palette.common.white,
      '--nav-border-color': 'transparent',
      '--nav-logo-border': theme.palette.neutral[700],
      '--nav-section-title-color': theme.palette.neutral[400],
      '--nav-item-color': theme.palette.navText,
      '--nav-item-hover-bg': 'rgba(255, 255, 255, 0.04)',
      '--nav-item-active-bg': 'rgba(255, 255, 255, 0.04)',
      '--nav-item-active-color': theme.palette.navActiveText,
      '--nav-item-disabled-color': theme.palette.neutral[500],
      // Item icons follow the feature-bar text colour so they stay legible on any
      // configured background; the active icon uses the primary colour as an accent.
      '--nav-item-icon-color': theme.palette.navText,
      '--nav-item-icon-active-color': theme.palette.primary.main,
      '--nav-item-icon-disabled-color': theme.palette.neutral[500],
      '--nav-item-chevron-color': theme.palette.navText,
      '--nav-scrollbar-color': theme.palette.neutral[400],
    }
  }, [theme]);
};

export default useCssVars;
